"use strict";

exports.__esModule = true;
exports.EditableGridElementLayer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _gridUtils = require("./gridUtils");
var _EditableGridElementBackground = require("./EditableGridElementBackground");
var _getDecoratedNode = require("../../../Utils/getDecoratedNode");
var _dec, _dec2, _class, _EditableGridElementLayer;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var widgetTarget = {
  hover: function hover(props, monitor, component) {
    var hasDroppedOnChild = monitor.didDrop();
    if (hasDroppedOnChild || !monitor.isOver({
      shallow: true
    })) {
      return;
    }
    var itemType = monitor.getItemType();
    if (itemType === "element") {
      var delta = monitor.getDifferenceFromInitialOffset();
      var _monitor$getItem = monitor.getItem(),
        element = _monitor$getItem.element;
      var x = Math.round((element.props.x || 0) + delta.x);
      var y = Math.round((element.props.y || 0) + delta.y);
      var _element$props = element.props,
        width = _element$props.width,
        height = _element$props.height;
      var _getGridCellPosition = (0, _gridUtils.getGridCellPosition)(props, {
          x: x,
          y: y,
          width: width,
          height: height
        }),
        gridRowStart = _getGridCellPosition.gridRowStart,
        gridRowEnd = _getGridCellPosition.gridRowEnd,
        gridColumnStart = _getGridCellPosition.gridColumnStart,
        gridColumnEnd = _getGridCellPosition.gridColumnEnd;
      props.onHover({
        x: x,
        y: y,
        width: width,
        height: height,
        gridRowStart: gridRowStart,
        gridRowEnd: gridRowEnd,
        gridColumnStart: gridColumnStart,
        gridColumnEnd: gridColumnEnd
      });
    } else if (itemType === "widget") {
      var componentNode = (0, _getDecoratedNode.getDecoratedNode)(component);
      var domNode = (0, _getDecoratedNode.resolveRelativeDropNode)(componentNode, props.path.length);
      if (domNode == null) {
        return;
      }
      var rect = domNode.getBoundingClientRect();
      var _delta = monitor.getSourceClientOffset();
      var _monitor$getItem2 = monitor.getItem(),
        widget = _monitor$getItem2.widget;
      var _x = Math.round(_delta.x - rect.left);
      var _y = Math.round(_delta.y - rect.top);
      var _width = widget.propConstraints.width["default"];
      var _height = widget.propConstraints.height["default"];
      var _getGridCellPosition2 = (0, _gridUtils.getGridCellPosition)(props, {
          x: _x,
          y: _y,
          width: _width,
          height: _height
        }),
        _gridRowStart = _getGridCellPosition2.gridRowStart,
        _gridRowEnd = _getGridCellPosition2.gridRowEnd,
        _gridColumnStart = _getGridCellPosition2.gridColumnStart,
        _gridColumnEnd = _getGridCellPosition2.gridColumnEnd;
      props.onHover({
        x: _x,
        y: _y,
        width: _width,
        height: _height,
        gridRowStart: _gridRowStart,
        gridRowEnd: _gridRowEnd,
        gridColumnStart: _gridColumnStart,
        gridColumnEnd: _gridColumnEnd
      });
    }
  },
  drop: function drop(props, monitor, component) {
    var elementEditor = props.elementEditor;
    var hasDroppedOnChild = monitor.didDrop();
    if (hasDroppedOnChild || !monitor.isOver({
      shallow: true
    })) {
      return;
    }
    var itemType = monitor.getItemType();
    if (itemType === "element") {
      var delta = monitor.getDifferenceFromInitialOffset();
      var _monitor$getItem3 = monitor.getItem(),
        element = _monitor$getItem3.element,
        path = _monitor$getItem3.path;
      var x = Math.round((element.props.x || 0) + delta.x);
      var y = Math.round((element.props.y || 0) + delta.y);
      var _element$props2 = element.props,
        width = _element$props2.width,
        height = _element$props2.height;
      var _getGridCellPosition3 = (0, _gridUtils.getGridCellPosition)(props, {
          x: x,
          y: y,
          width: width,
          height: height
        }),
        gridRowStart = _getGridCellPosition3.gridRowStart,
        gridRowEnd = _getGridCellPosition3.gridRowEnd,
        gridColumnStart = _getGridCellPosition3.gridColumnStart,
        gridColumnEnd = _getGridCellPosition3.gridColumnEnd;
      elementEditor.moveElementAt(path, props.path, {
        x: x,
        y: y,
        width: width,
        height: height,
        gridRowStart: gridRowStart,
        gridRowEnd: gridRowEnd,
        gridColumnStart: gridColumnStart,
        gridColumnEnd: gridColumnEnd
      });
    } else if (itemType === "widget") {
      var componentNode = (0, _getDecoratedNode.getDecoratedNode)(component);
      var domNode = (0, _getDecoratedNode.resolveRelativeDropNode)(componentNode, props.path.length);
      if (domNode == null) {
        return;
      }
      var rect = domNode.getBoundingClientRect();
      var _delta2 = monitor.getSourceClientOffset();
      var _monitor$getItem4 = monitor.getItem(),
        widget = _monitor$getItem4.widget;
      var _x2 = Math.round(_delta2.x - rect.left);
      var _y2 = Math.round(_delta2.y - rect.top);
      var _width2 = widget.propConstraints.width["default"];
      var _height2 = widget.propConstraints.height["default"];
      var _getGridCellPosition4 = (0, _gridUtils.getGridCellPosition)(props, {
          x: _x2,
          y: _y2,
          width: _width2,
          height: _height2
        }),
        _gridRowStart2 = _getGridCellPosition4.gridRowStart,
        _gridRowEnd2 = _getGridCellPosition4.gridRowEnd,
        _gridColumnStart2 = _getGridCellPosition4.gridColumnStart,
        _gridColumnEnd2 = _getGridCellPosition4.gridColumnEnd;
      var _element = widget.createElement({
        x: _x2,
        y: _y2,
        width: _width2,
        height: _height2,
        gridRowStart: _gridRowStart2,
        gridRowEnd: _gridRowEnd2,
        gridColumnStart: _gridColumnStart2,
        gridColumnEnd: _gridColumnEnd2
      });
      elementEditor.appendElementAt(props.path, _element);
    }
  }
};

/**
 * Displays an editable grid.
 */
var EditableGridElementLayer = exports.EditableGridElementLayer = (_dec = _ConfigurableLayout.ElementEditorContext.withContext, _dec2 = (0, _reactDnd.DropTarget)(["widget", "element"], widgetTarget, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({
      shallow: true
    })
  };
}), _dec(_class = _dec2(_class = (_EditableGridElementLayer = /*#__PURE__*/function (_Component) {
  function EditableGridElementLayer() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.node = null;
    _this.setNode = function (el) {
      _this.node = el;
    };
    _this.getNode = function () {
      return _this.node;
    };
    return _this;
  }
  _inheritsLoose(EditableGridElementLayer, _Component);
  var _proto = EditableGridElementLayer.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      padding = _this$props.padding,
      rowCount = _this$props.rowCount,
      columnCount = _this$props.columnCount,
      highlightedCells = _this$props.highlightedCells,
      children = _this$props.children,
      connectDropTarget = _this$props.connectDropTarget,
      isOver = _this$props.isOver,
      onContextMenu = _this$props.onContextMenu;
    var style = {
      position: "relative",
      width: width,
      height: height
    };
    return connectDropTarget(/*#__PURE__*/_react["default"].createElement("div", {
      ref: this.setNode,
      "data-testid": "EditableGridElementLayer",
      style: style,
      onContextMenu: onContextMenu
    }, /*#__PURE__*/_react["default"].createElement(_EditableGridElementBackground.EditableGridElementBackground, {
      rowCount: rowCount,
      columnCount: columnCount,
      width: width,
      height: height,
      padding: padding,
      highlightedCells: isOver ? highlightedCells : undefined
    }), children));
  };
  return EditableGridElementLayer;
}(_react.Component), _EditableGridElementLayer.defaultProps = {
  elementEditor: undefined,
  connectDropTarget: undefined,
  isOver: undefined
}, _EditableGridElementLayer)) || _class) || _class);